import _property from 'lodash/property'

const id = _property('id')
const name = _property('name')
const emr = _property('emr')

export default {
  id,
  name,
  emr
}
